export default "__VITE_ASSET__B1V$9WR$__"